export default {
  "fontElementMap": "MYTb-",
  "quote": "_9iu5l"
};